import React from 'react';

import Layout from 'layouts/Layout';
import NewAssortment from './NewAssortment';

const NewAssortmentLayout = ({ match }) => <Layout component={NewAssortment} match={match} />;

export default NewAssortmentLayout;
